/* ===========================
 * Provider Type Transformer
 * ===========================
 *
 * The transformer for the provider type
 */

import Transformer from './transformer';

export default class ProviderTypeTransformer extends Transformer {
  /**
   * Method used to transform a fetched profile
   *
   * @param profile The fetched profile
   *
   * @returns {Object} The transformed profile
   */
  static fetch(data) {
    return {
      id: this.getLangName(data.name, 'en').toLowerCase(),
      name: data.name,
      name_en: this.getLangName(data.name, 'en'),
      name_th: this.getLangName(data.name, 'th'),
      parent_id: data.parent_id,
      created_at: data.created_at,
      updated_at: data.created_at,
    };
  }

  static fetchProviderTypeCollectionForTable(items) {
    const newCollection = [];

    if (items.length === 0) {
      return newCollection;
    }

    items.forEach((item) => {
      newCollection.push({
        id: item.id,
        name_en: this.getLangName(item.name, 'en'),
        name_th: this.getLangName(item.name, 'th'),
        description_en: this.getLangName(item.description, 'en'),
        description_th: this.getLangName(item.description, 'th'),
        parent_id: item.parent_id,
        created_at: item.created_at,
        updated_at: item.created_at,
      });
    });

    return newCollection;
  }

  static getLangName(name, lang) {
    const nameObject = JSON.parse(name);

    return lang === 'en' ? nameObject.en : nameObject.th;
  }
}
